module.exports = __webpack_public_path__ + "img/banner.c3f0e828.png";